import { useMutation } from 'react-query';
import { createTopups } from 'services/topups';

export const useCreateTopups = () =>
  useMutation(payload => createTopups(payload));
